import { ResponseMapper } from '../../utils/httpclient/response/responsemapper';
import { APIFeatures } from '../util/apifeatures';
import { StatusCodes } from '../util/statuscodes';
import { SixdeeCRBTAPIProcessor } from './sixdeecrbtapiprocessor';
import { TimeBasedSettingForCallersGroupResponseDtoImpl, TimeBasedSettingForCallersGroupResponse } from '../api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgroupresponse';
import { TimeBasedSettingForCallersGroupRequest } from '../api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgrouprequest';
import { Strings } from '../../utils/resources/strings';

export class TimeBasedSettingForCallersGroupAPIProcessorImpl extends SixdeeCRBTAPIProcessor<TimeBasedSettingForCallersGroupRequest, TimeBasedSettingForCallersGroupResponse>
{
    execute(request: TimeBasedSettingForCallersGroupRequest): void 
    {
        super.execute(request);
    }

    onSuccess(responseMapper: ResponseMapper): void 
    {
        super.onSuccess(responseMapper);
        try {

            if (+responseMapper.getStatusCode() === StatusCodes.SUCCESS) {

                let response = new TimeBasedSettingForCallersGroupResponseDtoImpl(APIFeatures.TIME_BASED_SETTING_FOR_CALLERS_GROUP, "Time Based Setting for Callers Group Success");

                this.getAPISuccess(response);
            }
        }
        catch (e) {
            this.getAPIFailure(new TimeBasedSettingForCallersGroupResponseDtoImpl(APIFeatures.TIME_BASED_SETTING_FOR_CALLERS_GROUP, this.getContext().getResources().getString(Strings.internal_server_error)));
        }
    }

    onFailure(responseMapper: ResponseMapper): void 
    {
        super.onFailure(responseMapper);
      
            this.getAPIFailure(new TimeBasedSettingForCallersGroupResponseDtoImpl(APIFeatures.TIME_BASED_SETTING_FOR_CALLERS_GROUP, responseMapper.getStatusMsg()));
        
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/processor/timebasedsettingforcallersgroupapiprocessor.tsx